import { Card } from "@/components/ui/card";
import { Button } from "@/components/ui/button";
import { FileText, Download, Trash2, Eye } from "lucide-react";
import { formatDistanceToNow } from "date-fns";

interface DocumentGridProps {
  searchQuery: string;
}

// Mock data
const documents = [
  {
    id: 1,
    name: "Personal Statement.pdf",
    type: "application/pdf",
    size: "2.4 MB",
    uploadedAt: new Date("2025-01-15"),
    category: "Required"
  },
  {
    id: 2,
    name: "Recommendation Letter 1.pdf",
    type: "application/pdf",
    size: "1.8 MB",
    uploadedAt: new Date("2025-01-16"),
    category: "Required"
  },
  {
    id: 3,
    name: "CV.pdf",
    type: "application/pdf",
    size: "890 KB",
    uploadedAt: new Date("2025-01-17"),
    category: "Required"
  }
];

const DocumentGrid = ({ searchQuery }: DocumentGridProps) => {
  const filteredDocuments = documents.filter(doc =>
    doc.name.toLowerCase().includes(searchQuery.toLowerCase())
  );

  return (
    <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-4">
      {filteredDocuments.map((doc) => (
        <Card key={doc.id} className="p-4 hover:bg-accent/5 transition-colors">
          <div className="flex flex-col h-full">
            <div className="flex items-start justify-between mb-4">
              <div className="flex items-center gap-2">
                <FileText className="h-8 w-8 text-primary" />
                <div>
                  <p className="font-medium text-sm line-clamp-1">{doc.name}</p>
                  <p className="text-xs text-muted-foreground">{doc.size}</p>
                </div>
              </div>
            </div>
            
            <div className="mt-auto space-y-2">
              <p className="text-xs text-muted-foreground">
                Uploaded {formatDistanceToNow(doc.uploadedAt)} ago
              </p>
              
              <div className="flex gap-2">
                <Button variant="outline" size="sm" className="flex-1">
                  <Eye className="h-4 w-4 mr-1" />
                  Preview
                </Button>
                <Button variant="outline" size="sm" className="flex-1">
                  <Download className="h-4 w-4 mr-1" />
                  Download
                </Button>
                <Button variant="outline" size="sm" className="flex-none">
                  <Trash2 className="h-4 w-4 text-destructive" />
                </Button>
              </div>
            </div>
          </div>
        </Card>
      ))}
    </div>
  );
};

export default DocumentGrid;